// extracted by mini-css-extract-plugin
export default {"root":"vqKQ7F2OrqI43QOaqt9t","contentWrapper":"yOd4LLQV7oGFuzMyyD5A"};